import EastIcon from "@mui/icons-material/East"
import { Stack, Typography } from "@mui/material"
import { FC } from "react"

import { msalConfig } from "src/auth/msalConfig"
import { Button } from "src/components/common/button"
import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"

import { useAccount } from "src/states/account"
import { mergeDialog } from "src/states/dialogs"
import { useLocale } from "src/states/locale"

import styles from "./AccountProfile.module.scss"

const bem = create(styles, "AccountProfile")

export const PersonalData: FC = () => {
  const { messages: translations } = useTranslation()
  const account = useAccount()
  const locale = useLocale()
  const profileTranslations = translations.pages.account.overview.profile

  const data = [
    {
      label: profileTranslations.profile.firstName,
      value: account.firstName ?? "",
    },
    {
      label: profileTranslations.profile.name,
      value: account.lastName ?? "",
    },
    {
      label: profileTranslations.profile.email,
      value: account.email ?? "",
    },
    {
      label: profileTranslations.profile.phone,
      value: account.phone ?? "",
    },
  ]

  const resetPassword = () =>
    (window.location.href = `https://${process.env.AAD_TENANT_NAME}.b2clogin.com/${process.env.AAD_TENANT_NAME}.onmicrosoft.com/oauth2/v2.0/authorize?p=${process.env.AAD_RESET_PASSWORD_FLOW_NAME}&client_id=${process.env.AAD_CLIENT_ID}&nonce=defaultNonce&redirect_uri=${window.location.origin}${msalConfig.auth.redirectUri}&scope=openid%20${process.env.AAD_SCOPE}&response_type=id_token%20token&prompt=login&lang=${locale}`)

  const editProfile = () => {
    mergeDialog("editProfileDialog", { open: true })
  }

  return (
    <Stack className={bem("card")} direction={"column"}>
      <div className={bem("card", "header")}>
        <Typography variant="subtitle1">
          {profileTranslations.headers.profile}
        </Typography>
      </div>
      <Stack
        className={bem("card", "content")}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Stack direction={"column"}>
          {data.map((item) => (
            <Stack
              key={item.label}
              className={bem("data")}
              direction={"row"}
              justifyContent={"flex-start"}
            >
              <Typography variant={"body1"}>{item.label}:</Typography>
              <Typography variant={"body1"}>{item.value}</Typography>
            </Stack>
          ))}
        </Stack>
        <Stack direction={"column"} spacing={2}>
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon fontSize="small" />}
            title={profileTranslations.buttons.changePassword}
            onClick={() => resetPassword()}
          />
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon />}
            title={profileTranslations.buttons.editProfile}
            onClick={() => editProfile()}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
